import React from 'react'

import { Divider, Form, Row, Col } from '_zari/core'

import * as Tables from './tables'

const DetalleOrdenSection = ({
  infoDetalle,
  index,
  cantidadesAsignadas,
  setCantidadesAsignadas,
  flagVerOrdenesCerradas
}) => {
  const saldo = React.useMemo(() => {
    const ultimoMovimiento = infoDetalle.movimientos[infoDetalle.movimientos.length - 1]
    return ultimoMovimiento.saldo
  }, [infoDetalle.movimientos])

  const onChange = React.useCallback(
    e => {
      const nuevoValor = e.target.value

      setCantidadesAsignadas(prev => {
        const nuevoArr = [...prev]

        nuevoArr[index] = nuevoValor

        return nuevoArr
      })
    },
    [setCantidadesAsignadas, index]
  )

  return (
    <>
      <Divider
        title={`${infoDetalle.codigoProducto} - ${infoDetalle.nombreProducto} (${infoDetalle.nombreUnidadDeMedida})`}
      />
      <Tables.MovimientosTable idDetalle={infoDetalle._id} filas={infoDetalle.movimientos} />
      {!flagVerOrdenesCerradas && (
        <Row className='mt-2'>
          <Col md={7} />
          <Col md={5}>
            <Form.Group>
              <Form.Label text='CANTIDAD A RECIBIR' htmlFor={`${infoDetalle._id}-cantidad`} md={7} alignRightAt='md' />
              <Col md={5}>
                <Form.InputNumber
                  id={`${infoDetalle._id}-cantidad`}
                  name={`${infoDetalle._id}-cantidad`}
                  value={cantidadesAsignadas[index]}
                  onChange={onChange}
                  isInvalid={cantidadesAsignadas[index] > saldo || cantidadesAsignadas[index] < 0}
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
      )}
    </>
  )
}

export default React.memo(DetalleOrdenSection)
